module Engage.WebShop.View {
    export class StudentSubscriptionlView {
        constructor() {
            // Handle the form submit event, and make the Ajax request:
            $("#studentForm").on("submit", function (event) {
                //event.preventDefault();

                // Show the "busy" Gif:
                $("#progressSpinner").show();
            //    $(".formWrapper").attr('disabled', 'disabled');
                $('#submitButton').attr('disabled', 'disabled');
            });

            //hide error message when leaving fields
            $('input', "#studentForm").focusout(e => {
                $(".text-danger").hide();
            })
        }

    }

}

$(document).ready(function () {
    var myView = new Engage.WebShop.View.StudentSubscriptionlView();
    const scrollError = $("#scrollError")?.val()?.toString().toLowerCase() == "true"
    if (scrollError) {
        $('html, body').animate({
            scrollTop: $('#studentForm').offset().top
        }, 'slow');
    }

});